export enum LpEmailTemplate {
  OnboardingTasksEmail = 'OnboardingTasksEmail',
  PostSubscriptionInvitation = 'PostSubscriptionInvitation',
  OnboardingSubscriptionSuccessfullyCompletedEmail = 'OnboardingSubscriptionSuccessfullyCompletedEmail',
}
